import {FlowEnum} from 'presentation/pages/private/booking/constants';

export type HealthSpecialty = {
	sub_code?: string;
	sub_description?: string;
	telemedicine: string;
	multipleBookings?: boolean;
};

export type OdontoSpecialty = {
	sub_code?: string;
	sub_description?: string;
	telemedicine: string;
};

export type ExamSpecialty = {
	flPreparo: boolean;
	dsPreparo: string;
	dsInformacaoComplementar: string;
	flAutorizacao: boolean;
	flCarencia: boolean;
	dtCarencia: string;
	cdProcedimento: string;
};

type SpecialtyTypes = {
	[FlowEnum.HEALTH]: HealthSpecialty;
	[FlowEnum.TELEHEALTH]: HealthSpecialty;
	[FlowEnum.ODONTO]: OdontoSpecialty;
	[FlowEnum.EXAM]: ExamSpecialty;
};

type SpecialtyKeys = keyof SpecialtyTypes;

type Specialty<Type extends SpecialtyKeys = SpecialtyKeys> = {
	code: string;
	description: string;
	formattedText: string;
	telemedicine?: string;
	hasDefinition?: boolean;
	isFavoriteDoctorsFlow?: boolean;
	ufCode?: string;
	cityName?: string;
	flLivreDemanda?: boolean;
} & SpecialtyTypes[Type];

type CategorizedSpecialty = Record<string, Specialty[]>;

type SpecialtyList = {
	category: string;
	list: Specialty[];
};

function categorizeSpecialtiesByFirstLetter(specialties: Specialty[]): SpecialtyList[] {
	const categorizedSpecialties: CategorizedSpecialty = {};

	specialties.forEach(specialty => {
		const firstLetter = specialty.formattedText.charAt(0).toUpperCase();

		if (!categorizedSpecialties[firstLetter]) {
			categorizedSpecialties[firstLetter] = [];
		}

		categorizedSpecialties[firstLetter].push(specialty);
	});
	const entries = Object.entries(categorizedSpecialties);
	const parsedList = entries.map(item => ({
		category: item[0],
		list: item[1],
	}));

	return parsedList;
}

function isSelectedSpecialty(
	item: Specialty,
	specialtyCode: string,
	subSpecialtyCode?: string,
): boolean {
	if ('sub_code' in item) {
		return subSpecialtyCode === item.sub_code && specialtyCode === item.code;
	}
	return specialtyCode === item.code;
}

export {isSelectedSpecialty, categorizeSpecialtiesByFirstLetter};

export type {Specialty, SpecialtyList, SpecialtyKeys};
